import { FormControl } from '@angular/forms';
import { LUHN_INVALID } from '../validators/luhn-validators';
import { TOO_SHORT } from '../validators/min-length-without-spaces-validator';
import { TOO_LONG } from '../validators/max-length-without-spaces-validator';
import { BAD_FORMAT } from '../validators/month-format-validator';

declare module '@angular/forms' {
  interface FormControl {
    readonly missing: boolean;
    readonly luhnInvalid: boolean;
    readonly tooShort: boolean;
    readonly tooLong: boolean;
    readonly badFormat: boolean;
    readonly patternFail: boolean;
  }
}

Object.defineProperty(FormControl.prototype, 'missing', {
  get(this: FormControl) {
    return this.hasError('required');
  },
  enumerable: true,
  configurable: true,
});

Object.defineProperty(FormControl.prototype, 'luhnInvalid', {
  get(this: FormControl) {
    return this.hasError(LUHN_INVALID);
  },
  enumerable: true,
  configurable: true,
});

Object.defineProperty(FormControl.prototype, 'tooShort', {
  get(this: FormControl) {
    return this.hasError(TOO_SHORT);
  },
  enumerable: true,
  configurable: true,
});

Object.defineProperty(FormControl.prototype, 'tooLong', {
  get(this: FormControl) {
    return this.hasError(TOO_LONG);
  },
  enumerable: true,
  configurable: true,
});

Object.defineProperty(FormControl.prototype, 'badFormat', {
  get(this: FormControl) {
    return this.hasError(BAD_FORMAT);
  },
  enumerable: true,
  configurable: true,
});

Object.defineProperty(FormControl.prototype, 'patternFail', {
  get(this: FormControl) {
    return this.hasError('pattern');
  },
  enumerable: true,
  configurable: true,
});
